const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		// swiper配置
		swiperOption: {
			autoplay: true,
		},
		yearShowFlag: false,
		fullShowFlag: false,
		// 年份
		yearList: [],
		currentYear: '',
		currentPage: 1,
		rows: 20,
		moreFlag: false,
		// 现场列表
		sceneList: [],
		// 现场详情
		detailList: [],
		activeIndex: 1
	},
	computed: {
		swiper() {
			return this.$refs.mySwiper.swiper;
		}
	},
	methods: {
		// 获取年份
		getYears() {
			axios.post(baseURL + 'getAllFrontsceneNf')
				.then(res => {
					if (res.code == 200) {
						res.list.unshift({year: 0});
						res.list.forEach(item => {
							item.isActive = false;
						});
						res.list[0].isActive = true;
						this.yearList = res.list;
						this.currentYear = res.list[0].year;
						this.getSceneList();
					}
				})
				.catch(err => console.log(err));
		},
		// 获取培训现场
		getSceneList() {
			axios.post(baseURL + 'getAllFrontsceneG?page=' + this.currentPage + '&rows=' + this.rows + '&year=' + this.currentYear)
				.then(res => {
					if (res.code == 200) {
						if (res.list.length == 0) {
							return;
						}

						this.moreFlag = res.list.length == this.rows;
						this.sceneList = this.sceneList.concat(res.list);
					}
				})
				.catch(err => console.log(err));
		},
		// 切换年份
		changeYear(year) {
			this.yearList.forEach(item => {
				item.isActive = false;
			});
			year.isActive = true;

			this.sceneList.length = 0;
			this.currentPage = 1;
			this.moreFlag = false;
			this.sceneList = [];
			this.currentYear = year.year;
			this.getSceneList();
		},
		// 加载更多
		loadMore() {
			this.currentPage += 1;
			this.getSceneList();
		},
		// 查看培训详情
		readDetail(scene) {
			axios.post(baseURL + 'getsceneDq?id=' + scene.id)
				.then(res => {
					if (res.code == 200) {
						this.detailList = res.list;
						if (this.swiper) {
							this.swiper.activeIndex = 0;
							this.activeIndex = 1;
						}
						this.fullShowFlag = true;
					}
				})
				.catch(err => console.log(err));
		},
		changeActive() {
			this.activeIndex = this.swiper.activeIndex + 1;
		}
	},
	created() {
		this.getYears();
	}
});